export default class Season {
  constructor (data) {
    this.id = data.id
    this.name = data.name
  }
}
